import { render } from "./CustomAvatar.vue?vue&type=template&id=ce6ddcea"
import script from "./CustomAvatar.vue?vue&type=script&lang=js"
export * from "./CustomAvatar.vue?vue&type=script&lang=js"

import "./CustomAvatar.vue?vue&type=style&index=0&id=ce6ddcea&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__